<template>
  <div>
    <h2>Stevne aktivering - {{ competitionData && competitionData.id }}</h2>

    <div v-if="competitionData && competitionData.name">
      <h3>{{ competitionData.name }}</h3>
      <p :style="{ background: competitionData.adminApproved ? 'green' : 'lightcoral', borderRadius: '15px', padding: '5px 10px', display: 'inline-block' }">
        Aktiveringsstatus: {{ competitionData.adminApproved ? 'Stevnet er aktivert' : 'Stevnet er ikke aktivert' }}
      </p>
    </div>

    <!-- <div v-if="payment && payment.amount" >
      <h3>Betalingstatus</h3>
      <p>Betalingsid: {{ payment.id }}</p>
      <p>Sum: {{ (payment.amount/100) || 'N/A' }} </p>
      <p>Status: {{ payment.state === 'AUTHORIZED' ? 'Autorisert (mottak og aktivering av stevne gjenstår)' : payment.state === 'CAPTURED' ? 'Gjennomført' : payment.state }}</p>
    </div> -->

    <!-- {{ competition_activation_status || ''}}
    {{ competitionData }}
    <h3>Payment:</h3>
    {{ payment }} -->
    <br>
    <router-link to="/competitions" class="btn btn-primary">Tilbake til stevner</router-link>
  </div>
</template>

<script>

import CompetitionDataService from "../services/CompetitionDataService";
import vippsService from "../services/vipps.service";

export default {
  name: "competitionActivation",
  data() {
    return {
      competitionData: null,
      payments: [],
      payment: null,
      message: '',
      competition_activation_status: null
    };
  },
  methods: {
    getCompetition(competition_id) {
      console.log("getCompetition")
      CompetitionDataService.get(competition_id)
        .then(response => {
          this.competitionData = response.data[0];
          console.log(response.data[0]);
        })
        .catch(e => {
          console.log(e);
        });
    },
    // Initial retrieval of payments
    getPayments(competition_id) {
      console.log("getPayments")
      CompetitionDataService.getPayments(competition_id)
        .then(response => {
          this.payment = response.data[0];
          console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },
    getPaymentStatus(payment_id) {
      console.log("getPaymentStatus: " + payment_id)
      vippsService.getPaymentStatus(payment_id)
        .then(response => {
          this.payment = response.data;
          console.log('TODO: Update payment status');
          console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },
    competitionActivationStatus(competition_id) {
      console.log("competitionActivationStatus: " + competition_id)
      CompetitionDataService.competitionActivationStatus(competition_id)
        .then(response => {
          this.payment = response.data;
          console.log(response.data);
          if (this.competitionData && this.competitionData.id) {
            this.getCompetition(this.competitionData.id);
            return response.data;
          }
        })
        .catch(e => {
          console.log(e);
        });
    }


  },
  filters: {
    formatDate_onlyDate(value) {
      const date = new Date(value);
      return date.toLocaleDateString("no-NO", { year: 'numeric', month: 'numeric', day: 'numeric' });
    }
  },
  mounted() {
    console.log("CompetitionActivation - mounted")
    // this.getPayments(this.$route.params.competition_id);
    const competition_id = this.$route.params.competition_id;
    this.competitionData = {}
    this.competitionData.id = competition_id
    const payment_id = this.$route.params.payment_id;
    if (competition_id) {
      this.getCompetition(competition_id);
      // Get competition activation status
      this.competition_activation_status = this.competitionActivationStatus(competition_id);
    }
    if (payment_id) {
      this.getPaymentStatus(payment_id);
    }
    this.message = '';
  },
};
</script>

<style>
.edit-form {
  max-width: 300px;
  margin: auto;
}
</style>
